import * as React from 'react';
import { Link } from 'react-router-dom';
import { NavigationInformation } from '../../Model/NavigationInformation';
import { UriBuilder } from '../../Service/UriBuilder';
import { AbstractItem } from './AbstractItem';

export class GridItem extends AbstractItem {
    public render() {
        const props = this.props;
        const model = props.model;
        const className = 'job-center-list-item department-'
            + (model.department ? model.department.referenceId : '')
            + (model.highlight ? ' -highlight' : '');
        const uriBuilder = new UriBuilder();

        const to = {
            pathname: uriBuilder.uriForModel(model),
            state: {fromOverview: true} as NavigationInformation
        };

        return <div className="col-sm-12 col-md-6 col-lg-4" data-jc-refid={model.referenceId}>
            <Link to={to} className={className}>
                <div className="job">
                    <div className="title">
                        {model.title}
                        {this.renderIndicator(props)}
                    </div>
                    {/*<div className="reference-id">REF {model.referenceId}</div>*/}
                    <div className="industry">{model.industry?.name}</div>
                    <div className="location">{model.location}</div>
                    <div className="employment-type">{model.employmentType}</div>
                </div>
            </Link>
        </div>;
    }
}
